

const ProductsAddPage = () =>{
    return(
        <h1>This is add product page</h1>
    )
}

export default ProductsAddPage;